import { render } from "./ConversationTranscript.vue?vue&type=template&id=b3908206&scoped=true&lang=pug"
import script from "./ConversationTranscript.vue?vue&type=script&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&lang=js"

import "./ConversationTranscript.vue?vue&type=style&index=0&id=b3908206&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3908206"]])

export default __exports__